// extracted by mini-css-extract-plugin
module.exports = {"photo2":"FeedPhotosItem_photo2__2w35d","photo":"FeedPhotosItem_photo__fX07b","visualizacao":"FeedPhotosItem_visualizacao__2Ao4F"};